export interface MarketingParameter {
  id: string
  key: string
  value: string
  description?: string | null
  created_at: string
  updated_at: string
}

export const MARKETING_PARAM_DEPARTAMENTO = 'departamento_marketing'
